export default __webpack_public_path__ + "static/media/rounded-front.da816b40.webp";